import React, { useCallback, useMemo } from 'react';

import DiscussionListeners from './discussion-events';
import DocListeners from './doc-events';
import FileListeners from './file-events';
import MessageListeners from './message-events';
import MilestoneListeners from './milestone-events';
import NotificationListeners from './notification-events';
import ProjectListeners from './project-events';
import TaskListeners from './task-events';
import TaskGroupListeners from './task-group-events';
import TeamListeners from './team-events';
import UserListeners from './user-events';
import ActionListeners from './action-events';
import SubscribeListeners from './subscribe-events';
import LabelListeners from './label-events';
import TimeTrackingListeners from './time-tracking-events';
import CustomFieldListeners from './custom-field-events';
import SubteamListeners from './subteam-events';
import ProjectTemplateListeners from './project-template-events';
import BackgroundTaskListeners from './background-task-events';
import ExternalAccountListeners from './external-account-events';
import RecursionRuleListeners from './recursion-rule-events';
import FolderListeners from './folder-events';
import EmbedListeners from './embed-events';
import RoleListeners from './role-events';
import AutomationListeners from './automation-events';
import ActivityListeners from './activity-events';
import AnnotationListeners from './annotation-events';
import ConnectedCalendarsListeners from './connected-calendars-events';
import FavoriteListeners from './favorite-events';
import TasksViewListeners from './tasks-view-events';
import FormListeners from './form-events';
import TemplateListeners from './template-events';
import ChecklistListeners from './checklist-events';
import GoalListeners from './goal-events';
import GoalGroupListeners from './goal-group-events';

const SocketListeners = ({ eventEmitter, applyStoreAction, immidiateApplyStoreAction, currentUserId, currentTeamUrl }) => {
    const delayedApplyStoreAction = useCallback((...args) => {
        setTimeout(() => {
            applyStoreAction(...args);
        }, 300);
    }, [applyStoreAction]);

    const largeDelayedApplyStoreAction = useCallback((...args) => {
        setTimeout(() => {
            applyStoreAction(...args);
        }, 2000);
    }, [applyStoreAction]);

    const props = useMemo(() => ({ eventEmitter, applyStoreAction }), [eventEmitter, applyStoreAction]);

    return (
        <React.Fragment>
            <DiscussionListeners {...props} currentUserId={currentUserId} />
            <DocListeners {...props} currentUserId={currentUserId} />
            <FileListeners {...props} />
            <MessageListeners {...props} currentUserId={currentUserId} largeDelayedApplyStoreAction={largeDelayedApplyStoreAction} />
            <MilestoneListeners {...props} />
            <NotificationListeners {...props} />
            <ProjectListeners {...props} currentUserId={currentUserId} delayedApplyStoreAction={delayedApplyStoreAction} />
            <TaskListeners {...props} delayedApplyStoreAction={delayedApplyStoreAction} />
            <TaskGroupListeners {...props} />
            <TeamListeners {...props} currentTeamUrl={currentTeamUrl} />
            <UserListeners {...props} currentUserId={currentUserId} />
            <ActionListeners {...props} currentUserId={currentUserId} />
            <SubscribeListeners {...props} />
            <LabelListeners {...props} />
            <TimeTrackingListeners {...props} />
            <CustomFieldListeners {...props} delayedApplyStoreAction={delayedApplyStoreAction} />
            <SubteamListeners {...props} currentUserId={currentUserId} delayedApplyStoreAction={delayedApplyStoreAction} />
            <ProjectTemplateListeners {...props} delayedApplyStoreAction={delayedApplyStoreAction} />
            <BackgroundTaskListeners {...props} immidiateApplyStoreAction={immidiateApplyStoreAction} />
            <ExternalAccountListeners {...props} />
            <RecursionRuleListeners {...props} />
            <FolderListeners {...props} />
            <EmbedListeners {...props} />
            <RoleListeners {...props} />
            <AutomationListeners {...props} />
            <ActivityListeners {...props} />
            <AnnotationListeners {...props} />
            <ConnectedCalendarsListeners {...props} />
            <FavoriteListeners {...props} />
            <TasksViewListeners {...props} />
            <FormListeners {...props} />
            <TemplateListeners {...props} />
            <ChecklistListeners {...props} />
            <GoalListeners {...props} />
            <GoalGroupListeners {...props} />
        </React.Fragment>
    );
};

export default SocketListeners;
